import { pollRules, pendingLivePollRule } from '../constants/live-poll-rules';
import { isPendingLiveStream } from '../ui-selectors/video/live';
import { find } from 'lodash';
export const getPollStep = videoItem => {
  const {
    dateStartLive
  } = videoItem;
  const isPending = isPendingLiveStream(videoItem);
  if (isPending) {
    return pendingLivePollRule.step;
  }
  const timeGap = dateStartLive - Date.now(); // TODO: rewrite VideoItem

  const pollRule = find(pollRules, rule => timeGap < 0 ? timeGap > rule.timeToStart : rule.timeToStart > timeGap);
  return pollRule && pollRule.step;
};
//# sourceMappingURL=live-poll.js.map